// extracted by mini-css-extract-plugin
export default {"whyAttend":"LeadershipWhyAttend_whyAttend__G3fTW"};